<template>
  <div>
    <header class="header">
      <div class="wrapper">
        <div class="left">
          <router-link to="/" class="logo">
            <img src="../assets/ruststationlogo.svg" class="img" />
          </router-link>
        </div>
        <div class="center">
          <ul class="nav">
            <li class="nav__item">
              <div class="title small faq-link" @click="goToPage('faq')">
                {{ $t("FAQ") }}
              </div>
            </li>
            <!-- <li class="nav__item">
              <div class="title small" @click="scrollToSection('#footer')">
                {{ $t("SOCIAL NETWORK") }}
              </div>
            </li> -->
            <li class="nav__item">
              <router-link to="/products" class="title small">
                {{ $t("SHOP") }}
              </router-link>
            </li>
            <li class="nav__item">
              <router-link to="/cart" class="title small">
                {{ $t("CART") }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="right">
          <div
            class="select-container"
            v-if="curr && $parent.currencyOptions.length > 1"
          >
            <select
              class="select currency-select"
              v-model="curr"
              @change="selectCurr()"
            >
              <option :value="item" v-for="item in currOptions" :key="item">
                {{ item }}
              </option>
            </select>
          </div>
          <!-- <div class="balance" v-if="$parent.isAuth">
            <button class="button balance-btn">
              <div class="balance-text">
                <span class="balance-label">{{ $t("Balance") }}</span>
                <span class="balance-amount"
                  >{{ Math.floor($parent.profileData.balance * 100) / 100
                  }}{{ currency }}</span
                >
              </div>
              <div class="plus-button" @click="toggleTopUpDropdown">
                <img src="../images/plus_balance.svg" class="plus-icon" />
              </div>
            </button>
          </div> -->
          <router-link
            to="/profile"
            class="button profile-btn"
            v-if="$parent.isAuth"
          >
            <img src="../images/profile_pic.svg" class="profile-icon" />
            <span>{{ $t("PROFILE") }}</span>
          </router-link>
          <div
            class="button steam-login"
            v-if="!$parent.isAuth"
            @click="$parent.openSignInModal"
            @mouseenter="changeToWhiteIcon"
            @mouseleave="changeToRedIcon"
          >
            <span>{{ $t("LOGIN VIA STEAM") }}</span>
            <img
              ref="steamIcon"
              src="../assets/steamred.svg"
              class="steam-icon"
            />
          </div>
        </div>
      </div>
    </header>

    <!-- Mobile Dropdown Menu -->
    <div class="mobile-dropdown">
      <div class="mobile-dropdown-content">
        <div class="mobile-nav-section">
          <div class="mobile-nav-item" @click="goToPage('faq')">
            <span class="mobile-nav-text">{{ $t("FAQ") }}</span>
          </div>
          <div class="mobile-nav-item" @click="scrollToSection('#footer')">
            <span class="mobile-nav-text">{{ $t("SOCIAL NETWORK") }}</span>
          </div>
          <router-link to="/products" class="mobile-nav-item">
            <span class="mobile-nav-text">{{ $t("SHOP") }}</span>
          </router-link>
          <router-link to="/cart" class="mobile-nav-item">
            <span class="mobile-nav-text">{{ $t("CART") }}</span>
          </router-link>
        </div>

        <div class="mobile-actions-section">
          <div
            class="mobile-currency"
            v-if="curr && $parent.currencyOptions.length > 1"
          >
            <select
              class="mobile-currency-select"
              v-model="curr"
              @change="selectCurr()"
            >
              <option :value="item" v-for="item in currOptions" :key="item">
                {{ item }}
              </option>
            </select>
          </div>

          <!-- <div class="mobile-balance" v-if="$parent.isAuth">
            <div class="mobile-balance-info">
              <span class="mobile-balance-label">{{ $t("Balance") }}</span>
              <span class="mobile-balance-amount"
                >{{ Math.floor($parent.profileData.balance * 100) / 100
                }}{{ currency }}</span
              >
            </div>
            <button class="mobile-balance-btn" @click="openMobileTopUp">
              <img src="../images/plus_balance.svg" class="mobile-plus-icon" />
            </button>
          </div> -->

          <router-link
            to="/profile"
            class="mobile-profile-btn"
            v-if="$parent.isAuth"
          >
            <img src="../images/profile_pic.svg" class="mobile-profile-icon" />
            <span>{{ $t("PROFILE") }}</span>
          </router-link>

          <div
            class="mobile-steam-btn"
            v-if="!$parent.isAuth"
            @click="$parent.openSignInModal()"
            @mouseenter="changeToWhiteIcon"
            @mouseleave="changeToRedIcon"
          >
            <span>{{ $t("LOGIN VIA STEAM") }}</span>
            <img
              ref="mobileSteamIcon"
              src="../assets/steamred.svg"
              class="mobile-steam-icon"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="topup-modal"
      :class="{ active: topUpDropdownVisible }"
      v-if="$parent.isAuth"
    >
      <div class="wrapper">
        <div class="container">
          <div class="form">
            <div class="form-wrapper">
              <div class="form-fields">
                <div class="form-fields-wrapper">
                  <div class="title">{{ $t("TOP UP BALANCE") }}</div>
                  <div class="amount-section">
                    <div class="currency-label">{{ currency }}</div>
                    <div class="input-with-controls">
                      <input
                        type="number"
                        class="amount-input"
                        v-model="amount"
                        placeholder="0"
                        max="999999999999"
                      />
                      <div class="amount-controls">
                        <button class="amount-btn" @click="decreaseAmount">
                          -
                        </button>
                        <button class="amount-btn" @click="increaseAmount">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <button class="button" @click="toCheckout">
                    {{ $t("TOP UP BALANCE") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["currency", "currencyCode", "currencyValue"],
  data: function () {
    return {
      curr: "",
      topUpDropdownVisible: false,
      amount: 5,
    };
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code);
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue;
    },
  },
  mounted() {
    this.curr = this.currencyCode;
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    selectCurr() {
      localStorage.setItem("currency", this.curr);
      this.changeCurrency(this.curr);
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    goToPage(page) {
      this.$emit("goToPage", page);
    },
    changeToWhiteIcon() {
      if (this.$refs.steamIcon) {
        this.$refs.steamIcon.src = require("../assets/steamwhite.svg");
      }
      if (this.$refs.mobileSteamIcon) {
        this.$refs.mobileSteamIcon.src = require("../assets/steamwhite.svg");
      }
    },
    changeToRedIcon() {
      if (this.$refs.steamIcon) {
        this.$refs.steamIcon.src = require("../assets/steamred.svg");
      }
      if (this.$refs.mobileSteamIcon) {
        this.$refs.mobileSteamIcon.src = require("../assets/steamred.svg");
      }
    },
    toggleTopUpDropdown() {
      this.topUpDropdownVisible = !this.topUpDropdownVisible;
    },
    increaseAmount() {
      this.amount += 1;
    },
    decreaseAmount() {
      if (this.amount > 0) {
        this.amount -= 1;
      }
    },
    toCheckout() {
      if (this.amount > 0) {
        this.topUpDropdownVisible = false;
        this.$emit("setAmount", this.amount);
        this.$router.push({ path: "/topup", query: { amount: this.amount } });
      }
    },
    handleClickOutside(event) {
      if (
        !event.target.closest(".balance") &&
        !event.target.closest(".topup-modal")
      ) {
        this.topUpDropdownVisible = false;
      }
    },
    openMobileTopUp() {
      this.$parent.closeMenu();
      this.$parent.openTopUpModal();
    },
  },
};
</script>
